/* global globalThis */

import { apiClient as axios, API_URL, getAuthConfig, parseApiError } from './api';

// Не превращаем ошибки загрузки в [] и сохраняем HTTP-код для интерфейса.
export async function payrollRequest(token, path, { method = 'GET', data, signal } = {}) {
    try {
        const response = await axios({
            url: `${API_URL}/api/${path}`, method, data, signal, timeout: 30000,
            ...getAuthConfig(token),
        });
        return response.data;
    } catch (cause) {
        const status = cause.response?.status || 0;
        const error = new Error(status === 423
            ? 'Сейчас выполняется расчёт. Подожди и повтори запрос.'
            : parseApiError(cause.response?.data, 'Нет ответа сервера. Результат запроса пока неизвестен.'));
        error.status = status;
        error.uncertain = !status || status >= 500;
        throw error;
    }
}

export function newPayrollRequestId() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    if (!globalThis.crypto?.getRandomValues) throw new Error('Для изменения условий нужен HTTPS и современный браузер.');
    const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}